export default "/images/time_provided_sm.jpg?2a6ad52f55896f7229e244c057adf1de";